module.exports = __webpack_public_path__ + "static/media/icon-expand.1f7a84ad.svg";